import React, { useState } from 'react';
import { Box, Card, Stack, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import CusUploadImage from '../../../../../components/material-ui/CusUploadImage';
import CusInput from '../../../../../components/material-ui/CusInput';

const allLangs = [
  { title: 'Ru', code: 'ru' },
  { title: 'En', code: 'en' },
  { title: 'Es', code: 'es' },
  { title: 'Ar', code: 'ar' },
  { title: 'Az', code: 'az' },
  { title: 'Uz', code: 'uz' }
];

export default function BotLangs({ langs, changeBonusLangs }) {
  const { t } = useTranslation();
  const { isMobile } = useBootstrapSize();

  const [activeLang, setActiveLang] = useState(0);
  const onTabChange = (_, newValue) => setActiveLang(newValue);

  const chooseBonusKey = allLangs[activeLang].code;
  const chooseBonus = langs?.[chooseBonusKey];

  const changeField = (name, value) => {
    changeBonusLangs(name, value, chooseBonusKey);
  };

  return (
    <Box>
      <Tabs value={activeLang} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
        {allLangs?.map((tab, indx) => (
          <Tab
            key={indx}
            iconPosition="end"
            value={indx}
            style={{ fontWeight: 600 }}
            label={t(tab.title)}
          />
        ))}
      </Tabs>
      <Card variant="elevation">
        <Stack gap={2}>
          <CusUploadImage
            title={'Picture for the bot:'}
            id={'botImage'}
            imageSource={chooseBonus?.botImage}
            onChange={(value) => changeField('botImage', value)}
          />
          <CusInput
            rows={4}
            id={'botText'}
            label={'Message for the bot'}
            value={chooseBonus?.botText || ''}
            onChange={(e) => changeField('botText', e.target.value)}
          />
          <Stack display={'flex'} gap={2} flexDirection={isMobile ? 'column' : 'row'}>
            <CusUploadImage
              title={'Banner for desktop version (700x400):'}
              id={'desktopImage'}
              imageSource={chooseBonus?.desktopImage}
              onChange={(value) => changeField('desktopImage', value)}
            />
            <CusUploadImage
              title={'Banner for mobile version (360x650):'}
              id={'mobileImage'}
              imageSource={chooseBonus?.mobileImage}
              onChange={(value) => changeField('mobileImage', value)}
            />
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
}
